import { HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of, pipe } from 'rxjs';
import { ApiService } from '../api/api.service';

@Injectable({
  providedIn: 'root'
})
export class PeopleProfileService {
  path = "people/";

  constructor(
    private apiService: ApiService
  ) { }

  getProfile(profileId: string | null, queryParam): Observable<any> {
    let params = new HttpParams();
    for (let key in queryParam) {
      if (queryParam.hasOwnProperty(key)) {
        params = params.set(key, queryParam[key]);
      }
    }
    const path = this.path+'organisation/profile/'+profileId;
    return this.apiService.get(path, {params: params});
  }

  postRehireStatus(rehireStatus: number, profileId: string | null): Observable<any> {
    let body = {'rehire_status': rehireStatus}
    const path = this.path+'organisation/profile/'+profileId;
    return this.apiService.post(path, body);
  }

  putProfile(profileId: string, dataBody: any): Observable<any> {
    const path = this.path+'organisation/profile/'+profileId;
    return this.apiService.put(path, dataBody);
  }
}
